<template>
  <div class="container mb-5">
    <div class="row mb-5 my-md-5">
      <div class="col-sm-6 offset-sm-3">
        <h1 class="text-center">
          {{ $t("ticketMedioDeVendas") }}
        </h1>
      </div>
    </div>
    <VisionThreeCharts />
  </div>
</template>

<script>
import VisionThreeCharts from './components/VisionThreeCharts.vue';

export default {
  components: { VisionThreeCharts },
};
</script>
